// extracted by mini-css-extract-plugin
module.exports = {"link":"MenuTeaser__link","image":"MenuTeaser__image"};